import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const ExportProgressMeter = ({ progress, segments, status }) => {
  const filledSegments = Math.floor(progress * segments);
  const hasActiveSegment = status === 'active' && filledSegments < segments;

  return (
    <div className="export-progress-meter">
      <div className="export-progress-segments">
        {Array.from({ length: segments }, (_, i) => {
          let segmentClass = 'export-progress-segment';

          if (i < filledSegments) {
            segmentClass += ' export-progress-segment--filled';
          } else if (i === filledSegments && hasActiveSegment) {
            segmentClass += ' export-progress-segment--active';
          }

          return <div key={i} className={segmentClass} />;
        })}
      </div>
      <span className="export-progress-value">
        {Math.round(progress * 100)}%
      </span>
    </div>
  );
};

ExportProgressMeter.propTypes = {
  progress: PropTypes.number.isRequired,
  segments: PropTypes.number,
  status: PropTypes.oneOf(['idle', 'active', 'complete']),
};

ExportProgressMeter.defaultProps = {
  segments: 10,
  status: 'idle',
};

export default ExportProgressMeter;
